import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from '@heroicons/react/24/outline';
import BuyFromWallet from './BuyFromWallet';
import BuyFromCrypto from './BuyFromCrypto';
import BuyFromFiat from './BuyFromFiat';
import Btc1TransactionHistory from './Btc1TransactionHistory';
import useAuthStore from '../../store/useAuthStore';


const QuickSwapPageComponent = () => {
  const [activeTab, setActiveTab] = useState('wallet');
  const { isAuthenticated } = useAuthStore();

  const tabs = [
    { id: 'wallet', label: 'Buy from Wallet', icon: '1'  },
    { id: 'crypto', label: 'Buy from Crypto', icon: '2' },
    { id: 'fiat', label: 'Buy from Fiat', icon: '3' },
    { id: 'history', label: 'Transaction History', icon: '4' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'wallet':
        return <BuyFromWallet activeTab={activeTab} />;
      case 'crypto':
        return <BuyFromCrypto activeTab={activeTab} />;
      case 'fiat':
        return <BuyFromFiat activeTab={activeTab} />;
      case 'history':
        // Only render Btc1TransactionHistory if authenticated
        if (!isAuthenticated) {
          return (
            <div className="bg-[#010615] rounded-xl border border-gray-700 p-6 mt-12">
              <div className="text-center py-12">
                <ClockIcon className="h-16 w-16 mx-auto mb-4 text-white" />
                <h3 className="text-xl font-semibold text-white mb-2">Sign in to view your orders</h3>
                <p className="text-white mb-6">Track your trading activity and order history</p>
                <div className="flex justify-center space-x-4">
                  <Link 
                    to="/login" 
                    className="!bg-[#0E1696] hover:bg-[#0E1696] !text-white px-6 py-2 rounded-lg font-medium transition-colors"
                  >
                    Sign In
                  </Link>
                  <Link 
                    to="/register" 
                    className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
                  >
                    Register
                  </Link>
                </div>
              </div>
            </div>
          );
        }
        return <Btc1TransactionHistory />;
      default:
        return <BuyFromWallet />;
    }
  };

  return (
    <div className="min-h-screen relative md:mt-20 mt-8">
      <div className="max-w-md sm:max-w-lg lg:max-w-7xl mx-auto relative z-10">
        <div className="flex flex-row gap-4 mt-4 sm:mt-6 lg:mt-[44px]">
          {/* Tab Navigation - 20% width */}
          <div className="w-[20%] px-2 sm:px-4">
            <div className="flex flex-col space-y-3 sm:space-y-4">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex flex-row items-center space-x-3 p-3 rounded-lg transition-all duration-200 ${
                    activeTab === tab.id
                      ? 'text-white bg-gray-800'
                      : 'text-white hover:text-white hover:bg-gray-800'
                  }`}
                >
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                    activeTab === tab.id
                      ? 'bg-[#0E1696] !text-white shadow-lg'
                      : '!bg-gray-600 text-white hover:!bg-gray-400'
                  }`}>
                    <span className="text-lg sm:text-xl font-semibold">{tab.icon}</span>
                  </div>
                  <span className="text-xs sm:text-sm font-medium leading-tight">{tab.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content - 80% width */}
          <div className="w-[80%] relative z-10 backdrop-blur-sm">
          {activeTab === 'fiat' && (
          <div className="text-3xl font-bold text-center text-white">Buy from Fiat</div>
        )}
        {activeTab === 'crypto' && (
          <div className="text-3xl font-bold text-center text-white">Buy from Crypto</div>
        )}
        {activeTab === 'wallet' && (
          <div className="text-3xl font-bold text-center text-white">Buy from Wallet</div>
        )}
        {activeTab === 'history' && (
          <div className="text-3xl font-bold text-center text-white">Transaction History</div>
        )}
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickSwapPageComponent; 